import React from "react"
import { CheckCircle2 } from "lucide-react"
import { Link } from "react-router-dom"
import { STUDENT_BASE_PATH } from "../../../../component/student/config/studentNavItems"
import "./DashboardHeader.style.scss"

interface DashboardHeaderProps {
  firstName: string
}

const DashboardHeader = ({ firstName }: DashboardHeaderProps) => (
  <header className="dashboard-header">
    <div className="dashboard-header__copy">
      <h1>Welcome back, {firstName || "Learner"}! 👋</h1>
      <p>Ready to smash your revision goals today?</p>
    </div>
    <Link
      to={`${STUDENT_BASE_PATH}/questions`}
      className="dashboard-header__cta"
    >
      <CheckCircle2 size={16} />
      Resume Practice
    </Link>
  </header>
)

export default DashboardHeader
